import React from 'react';
import { HeartIcon, FacebookIcon, LinkedinIcon, TwitterIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="contact" className="bg-dark text-white pt-20 pb-10" data-id="element-91">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16" data-id="element-93">
          {/* Company Info */}
          <div className="space-y-6" data-id="element-94">
            <div className="flex items-center" data-id="element-95">
              <img src="https://cdn.magicpatterns.com/uploads/oV66CvE5T9DxmmC6cXmgrm/ChatGPT_Image_Mar_27__2026__07_43_24_PM-removebg-preview.png" alt="Edvin Home Healthcare Logo" className="h-12 w-12 object-contain mr-3" data-id="element-96" />
              <span className="font-bold text-xl tracking-tight" data-id="element-97">
                Edvin Home Healthcare
              </span>
            </div>
            <p className="text-gray-400 leading-relaxed" data-id="element-98">
              Personalized, professional, and trusted nursing services delivered
              with care and dignity in the comfort of your home.
            </p>
            <div className="flex space-x-4" data-id="element-99">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-100">
                <FacebookIcon className="h-5 w-5" data-id="element-101" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-102">
                <TwitterIcon className="h-5 w-5" data-id="element-103" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-104">
                <LinkedinIcon className="h-5 w-5" data-id="element-105" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-106">
            <h3 className="text-lg font-bold mb-6 border-b border-white/10 pb-2 inline-block" data-id="element-107">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-108">
              <li data-id="element-109">
                <a href="#/" className="text-gray-400 hover:text-white transition-colors block" data-id="element-110">
                  Home
                </a>
              </li>
              <li data-id="element-111">
                <a href="#/about" className="text-gray-400 hover:text-white transition-colors block" data-id="element-112">
                  About Us
                </a>
              </li>
              <li data-id="element-113">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-114">
                  Services
                </a>
              </li>
              <li data-id="element-115">
                <a href="#/resources" className="text-gray-400 hover:text-white transition-colors block" data-id="element-116">
                  Resources
                </a>
              </li>
              <li data-id="element-117">
                <a href="#/faq" className="text-gray-400 hover:text-white transition-colors block" data-id="element-118">
                  FAQs
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-119">
            <h3 className="text-lg font-bold mb-6 border-b border-white/10 pb-2 inline-block" data-id="element-120">
              Our Services
            </h3>
            <ul className="space-y-3" data-id="element-121">
              <li data-id="element-122">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-123">
                  In-home Care
                </a>
              </li>
              <li data-id="element-124">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-125">
                  Physical Therapy
                </a>
              </li>
              <li data-id="element-126">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-127">
                  Wound Care
                </a>
              </li>
              <li data-id="element-128">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-129">
                  Respite Care
                </a>
              </li>
              <li data-id="element-130">
                <a href="#/services" className="text-gray-400 hover:text-white transition-colors block" data-id="element-131">
                  Occupational Therapy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-132">
            <h3 className="text-lg font-bold mb-6 border-b border-white/10 pb-2 inline-block" data-id="element-133">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-134">
              <li className="flex items-start" data-id="element-135">
                <PhoneIcon className="h-5 w-5 text-primary mr-3 mt-1 flex-shrink-0" data-id="element-136" />
                <div className="text-gray-400" data-id="element-137">
                  <p data-id="element-138">Cell: (240) 535-8731</p>
                  <p data-id="element-139">Office: (800) 579-0970</p>
                  <p data-id="element-140">Office 2: (301) 586-4767</p>
                </div>
              </li>
              <li className="flex items-center" data-id="element-141">
                <MailIcon className="h-5 w-5 text-primary mr-3 flex-shrink-0" data-id="element-142" />
                <a href="mailto:info@edvinhomehealth.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-143">
                  info@edvinhomehealth.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-144">
                <MapPinIcon className="h-5 w-5 text-primary mr-3 mt-1 flex-shrink-0" data-id="element-145" />
                <span className="text-gray-400" data-id="element-146">
                  Serving the local community with compassionate care.
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm" data-id="element-147">
          <p data-id="element-148">
            &copy; {currentYear} Edvin Home Healthcare Solutions and Nursing
            Services LLC. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 space-x-4" data-id="element-149">
            <a href="#" className="hover:text-white transition-colors" data-id="element-150">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-151">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}